import React from "react";
import Svg, { Path } from "react-native-svg";

interface LinkIconProps {
  size?: number;
  color?: string;
}

const LinkIcon: React.FC<LinkIconProps> = ({
  size = 16,
  color = "#005CBC",
}) => {
  return (
    <Svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      preserveAspectRatio="xMidYMid meet"
    >
      <Path
        d="M11.3334 4.66669H8.66671V6.00002H11.3334C12.4334 6.00002 13.3334 6.90002 13.3334 8.00002C13.3334 9.10002 12.4334 10 11.3334 10H8.66671V11.3334H11.3334C13.1734 11.3334 14.6667 9.84002 14.6667 8.00002C14.6667 6.16002 13.1734 4.66669 11.3334 4.66669ZM7.33337 10H4.66671C3.56671 10 2.66671 9.10002 2.66671 8.00002C2.66671 6.90002 3.56671 6.00002 4.66671 6.00002H7.33337V4.66669H4.66671C2.82671 4.66669 1.33337 6.16002 1.33337 8.00002C1.33337 9.84002 2.82671 11.3334 4.66671 11.3334H7.33337V10ZM5.33337 7.33335H10.6667V8.66669H5.33337V7.33335Z"
        fill={color}
      />
    </Svg>
  );
};

export default LinkIcon;
